import { makeRequest } from "../http-common";

const PolicyTypeDataService = {

    getAll: async function() {
        return makeRequest("get", "/policytype");
    },

    getById: async function(id) {
        return makeRequest("get", `/policytype/${id}`);
    },

    update: async function(id, data) {
        return makeRequest("put", `/policytype/${id}`, data);
    },

    create: async function(data) {
        return makeRequest("post", "/policytype", data);
    },

}

export default PolicyTypeDataService;